import { withErrorBoundary } from "@sentry/nextjs";
import { useKeenSlider } from "keen-slider/react";
import { FC } from "react";
import styled from "styled-components";
import { theme } from "styles";
import { Carousel6Content } from "types/graphql/generated";
import { Card } from "./Card";

interface Props {
  className?: string;
  content: Carousel6Content;
}

const Carousel6Mobile: FC<Props> = withErrorBoundary(({ className = "", content: { carousel6Options } }) => {
  const [ref] = useKeenSlider<HTMLDivElement>({
    slides: {
      perView: 1.04,
      spacing: 16,
    },
    breakpoints: {
      [`(min-width: ${theme.breakpoints.md + 1}px)`]: {
        disabled: true,
      },
    },
  });

  return (
    <StyledCarousel6Mobile className={className}>
      <div ref={ref} className="keen-slider Carousel6__Carousel">
        {carousel6Options.map((option) => (
          <div key={option.id} className="keen-slider__slide Carousel__listItem">
            <Card content={option} />
          </div>
        ))}
      </div>
    </StyledCarousel6Mobile>
  );
}, {});

const StyledCarousel6Mobile = styled.div`
  .Carousel6__Carousel {
    display: none !important;
  }

  @media (max-width: 660px) {
    .Carousel6__Carousel {
      display: flex !important;
      overflow: visible;
    }
  }
`;

export { Carousel6Mobile };
